var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFolderCopy = function SvgFolderCopy(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 21q-.824 0-1.412-.587A1.93 1.93 0 0 1 1 19V7q0-.424.288-.713A.97.97 0 0 1 2 6q.424 0 .712.287Q3 6.576 3 7v12h16q.424 0 .712.288.288.287.288.712 0 .424-.288.712A.97.97 0 0 1 19 21zm4-4q-.824 0-1.412-.587A1.93 1.93 0 0 1 5 15V4q0-.824.588-1.412A1.93 1.93 0 0 1 7 2h4.175a1.98 1.98 0 0 1 1.4.575L14 4h7q.824 0 1.413.588Q23 5.175 23 6v9q0 .824-.587 1.413A1.93 1.93 0 0 1 21 17zm0-2h14V6h-7.825l-2-2H7z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFolderCopy);
export { ForwardRef as ReactComponent };